var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkirute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    "data-name": "Cirkel"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    ry: 7.795,
    fill: "#0072bc"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10.621,4.844c.129.44-.123.902-.563,1.031s-.901-.123-1.03-.564.123-.901.563-1.03.901.122,1.03.562h0Zm0,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.26,8.879c-.21,0-.38.17-.38.381,0,.326-.265.591-.591.591l-1.581-.004.236-1.377c.011-.523-.405-.958-.929-.968h-.041s.404-.315.404-.315l1.923.063c.042.001.082-.004.12-.015.153-.045.267-.184.273-.353.007-.21-.158-.386-.368-.393l-1.323-.044c.034-.202-.012-.417-.147-.592-.124-.159-.305-.263-.506-.288-.2-.025-.402.03-.562.154l-.651.505-2.825-.758.074-.275c.041-.152-.05-.309-.202-.35-.152-.04-.309.05-.349.202l-.074.275-.368-.098c-.151-.041-.309.05-.349.202-.041.152.05.309.202.35l.367.098-.074.276c-.04.152.05.309.202.349.052.014.105.013.153-.002.093-.027.169-.1.196-.2l.074-.276,2.407.645-.81.629c-.316.246-.445.666-.318,1.048.126.381.48.642.88.65l1.088.023.177.838-2.694.006c-.21,0-.38.17-.38.38,0,.21.17.381.38.38l5.396-.003c.131,0,.259-.019.379-.054.562-.165.972-.685.973-1.299,0-.21-.171-.38-.381-.38h0Zm0,0",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "ICONS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.557,11.951H3.033c-.083,0-.15-.067-.15-.15s.067-.15.15-.15h9.524c.083,0,.15.067.15.15s-.067.15-.15.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.016,12.798H3.574c-.083,0-.15-.067-.15-.15s.067-.15.15-.15h8.442c.083,0,.15.067.15.15s-.067.15-.15.15Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkirute);
export default __webpack_public_path__ + "static/media/SKIRUTE.50c74a2c958e2f5e9e32a0a8dfa78818.svg";
export { ForwardRef as ReactComponent };